import { Box, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useRef, useState } from 'react';

import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';
import useLogout from 'Domain/logout/usePostLogout';
import usePatchChangeDevice from 'Domain/monitoring/usePatchChangeDevice';
import { changeDeviceModalText, presenceModalText } from 'Const/monitoring/view';

import FaceTracking from 'View/monitoring/component/face-tracking';

import styles from './styles.module.css';

const ChangeDeviceModal = ({ monitoringStatus }) => {
  const NOW = Date.now();
  const [isFaceDetected, setIsFaceDectected] = useState(false);
  const { mutate: onLogout } = useLogout();
  const { mutate: onPatchChangeDevice } = usePatchChangeDevice();

  const lastFacePositionRef = useRef(null);
  const lastMovementTimeRef = useRef(NOW);

  const onTracking = (value) => setIsFaceDectected(value);
  const onSubmitChangeDevice = () => onPatchChangeDevice({ monitoringStatus });

  const faceDetectedLabel = isFaceDetected ? presenceModalText.ensureFaceVisibleText : presenceModalText.faceNotDetectedText;

  return (
    <Modal isOpen={true}>
      <ModalOverlay className="change-device__modal--overlay" />
      <ModalContent maxWidth={'400px'} className="change-device__modal--content">
        <Box className={styles['change-device-modal__container']}>
          {/* Head */}
          
          <Box className={styles['change-device-modal__section--head']}>
            <TextBold className={styles['title__text']}>Pindah Perangkat?</TextBold>
          </Box>

          {/* Content */}

          <Box className={styles['change-device-modal__section--content']}>
            <TextRegular className={styles['ask-confirmation__text']}>{changeDeviceModalText.continueWorkPromptText}</TextRegular>
            <FaceTracking
              lastFacePositionRef={lastFacePositionRef}
              lastMovementTimeRef={lastMovementTimeRef}
              height="198px"
              width="352px"
              isOpen
              className={styles['camera__video']}
              onTracking={onTracking}
              isMonitoring
            />
            <TextRegular className={styles['camera-information__text']} color={isFaceDetected ? 'var(--color-semantic-text)' : 'var(--color-error50)'}>
              {faceDetectedLabel}
            </TextRegular>
          </Box>

          {/* Footer */}

          <Box className={styles['change-device-modal__section--footer']}>
            <ButtonOutline className={styles['cancel-login__button']} onClick={onLogout}>
              {changeDeviceModalText.cancelLoginText}
            </ButtonOutline>
            <ButtonSolid className={styles['continue-change-device__button']} disabled={!isFaceDetected} onClick={onSubmitChangeDevice}>
              {changeDeviceModalText.submitChangeDeviceText}
            </ButtonSolid>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default ChangeDeviceModal;
